import { type ReactNode } from 'react';

type TrackSectionPanelProps = {
  children: ReactNode;
  className?: string;
  sectionKey: string;
};

const TrackSectionPanel = ({
  children,
  className = '',
  sectionKey,
}: TrackSectionPanelProps) => (
  <div key={sectionKey} className={`track-section-panel ${className}`.trim()}>
    {children}
  </div>
);

export { TrackSectionPanel };
